import {
  GetStripeCheckout,
  GetStripeCheckoutQuery,
  ApiClientError,
} from '@raydiant/api-client-js';
import raydiant from '../clients/miraClient';
import useProtectedQuery from './useProtectedQuery';
import { keys } from '../queryClient';

export type UseGetStripeCheckoutOptions = GetStripeCheckoutQuery & {
  enabled?: boolean;
  refetchInterval?: number;
};

export default function useGetStripeCheckoutStatus(
  sessionId?: string,
  opts: UseGetStripeCheckoutOptions = {},
) {
  const query = useProtectedQuery<GetStripeCheckout, ApiClientError>(
    keys.stripeCheckout(sessionId),
    () => raydiant.getStripeCheckout({ sessionId }),
    {
      enabled: opts.enabled && !!sessionId,
      refetchInterval: opts.refetchInterval,
    },
  );

  return query;
}
